(function () {
  var settings = window.iwSettings || {};

  /* Mobile menu */
  function initMenu() {
    var toggle = document.querySelector('[data-iw-menu-toggle]');
    var nav = document.getElementById('iw-nav');
    if (!toggle || !nav) return;
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* Tabs (companies vs individuals) */
  function initTabs(root) {
    root.querySelectorAll('[data-iw-tabs]').forEach(function (tabs) {
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      function select(btn) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { select(btn); });
        btn.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          var next = buttons[(i + dir + buttons.length) % buttons.length];
          select(next);
          next.focus();
        });
      });
    });
  }

  /* Booking card -> WhatsApp (or booking link) */
  function initBooker(root) {
    root.querySelectorAll('[data-iw-booker]').forEach(function (form) {
      var where = form.querySelector('[data-iw-where]');
      var cars = form.querySelector('[data-iw-cars]');
      var hint = form.querySelector('[data-iw-hint]');

      function tooFewForHome() {
        return where && cars && where.value.indexOf('Home') === 0 && ['1', '2'].indexOf(cars.value) !== -1;
      }
      function update() { if (hint) hint.hidden = !tooFewForHome(); }
      if (where) where.addEventListener('change', update);
      if (cars) cars.addEventListener('change', update);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (tooFewForHome()) {
          update();
          cars.focus();
          return;
        }
        var data = new FormData(form);
        if (form.dataset.productUrl) {
          var target = new URL(form.dataset.productUrl, window.location.href);
          target.searchParams.set('variant', data.get('variant'));
          target.searchParams.set('qty', data.get('cars'));
          target.searchParams.set('where', data.get('where'));
          window.location.href = target.toString();
          return;
        }
        if (settings.bookingUrl) {
          var url = new URL(settings.bookingUrl, window.location.href);
          data.forEach(function (v, k) { if (v) url.searchParams.set(k, v); });
          window.location.href = url.toString();
          return;
        }
        var lines = [
          "Hi iWashCars, I'd like to book a wash.",
          '• Booking for: ' + data.get('who'),
          '• Location type: ' + data.get('where'),
          data.get('area') ? '• Area: ' + data.get('area') : null,
          '• Cars: ' + data.get('cars')
        ].filter(Boolean);
        var wa = 'https://wa.me/' + (settings.whatsapp || '') + '?text=' + encodeURIComponent(lines.join('\n'));
        window.open(wa, '_blank', 'noopener');
      });
    });
  }

  /* Booking product page: car picker, cars stepper, prefill from the homepage card */
  function initProduct(root) {
    root.querySelectorAll('[data-iw-pdp]').forEach(function (pdp) {
      var idInput = pdp.querySelector('[data-iw-variant-input]');
      var price = pdp.querySelector('[data-iw-price]');
      var media = pdp.querySelector('[data-iw-pdp-image] img');
      var qty = pdp.querySelector('[data-iw-qty]');
      var where = pdp.querySelector('[data-iw-where]');
      var buy = pdp.querySelector('button[name="add"]');

      pdp.querySelectorAll('input[type="radio"][data-price]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked || !idInput) return;
          idInput.value = radio.value;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          if (price) price.textContent = radio.dataset.price;
          if (media && radio.dataset.image) { media.removeAttribute('srcset'); media.src = radio.dataset.image; }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url.toString());
        });
      });

      pdp.querySelectorAll('[data-iw-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qty) return;
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.iwStep, 10));
          qty.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      function checkHome() {
        if (!where || !qty || !buy) return;
        var tooFew = where.value.indexOf('Home') === 0 && (parseInt(qty.value, 10) || 1) < 3;
        buy.toggleAttribute('data-needs-3', tooFew);
        pdp.classList.toggle('iw-pdp--home-warning', tooFew);
      }
      if (where) where.addEventListener('change', checkHome);
      if (qty) qty.addEventListener('change', checkHome);

      var params = new URLSearchParams(window.location.search);
      if (qty && params.get('qty')) qty.value = Math.max(1, parseInt(params.get('qty'), 10) || 1);
      if (where && params.get('where')) {
        Array.prototype.forEach.call(where.options, function (o) { if (o.value === params.get('where')) where.value = o.value; });
      }
      checkHome();
    });
  }

  /* Phone booking bar: hides while a real booking button is on screen; on the booking page it presses that button */
  function initStickyBar() {
    var bar = document.querySelector('[data-iw-sticky]');
    if (!bar) return;
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-iw-sticky-hide]'));
    var visible = new Set();
    function update() {
      var show = visible.size === 0 && window.scrollY > 120;
      bar.hidden = !show;
      document.body.classList.toggle('iw-has-sticky', show);
    }
    if ('IntersectionObserver' in window && targets.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
        update();
      });
      targets.forEach(function (t) { io.observe(t); });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();

    var buy = bar.querySelector('[data-iw-sticky-buy]');
    if (buy) {
      buy.addEventListener('click', function () {
        var real = document.querySelector('.iw-pdp__buy .cowlendar-btn:not(.cowlendar-hidden)') ||
                   document.querySelector('.iw-pdp__buy button[name="add"]:not(.cowlendar-hidden)');
        if (real) { real.scrollIntoView({ block: 'center' }); real.click(); }
      });
      document.addEventListener('change', function (e) {
        var r = e.target;
        if (!r.matches || !r.matches('.iw-pdp input[type="radio"][data-price]') || !r.checked) return;
        var price = bar.querySelector('[data-iw-sticky-price]');
        var title = bar.querySelector('[data-iw-sticky-title]');
        if (price) price.textContent = r.dataset.price;
        var name = r.closest('label') && r.closest('label').querySelector('.iw-pill__name');
        if (title && name) title.textContent = name.textContent;
      });
    }
  }

  function init(root) {
    initTabs(root || document);
    initBooker(root || document);
    initProduct(root || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    init(document);
    initStickyBar();
  });

  /* Re-run when sections are edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[role="tabpanel"]');
    if (!panel) return;
    var btn = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (btn) btn.click();
  });
})();
